import { useState } from 'react';

export default function Footer() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;

    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formData = new FormData();
      formData.append('email', email);
      formData.append('recipient', 'news@propfirmpolice.com');

      const response = await fetch('https://readdy.ai/api/form/d4clhbedhknumrhf67jg', {
        method: 'POST',
        body: new URLSearchParams(formData as any),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
      });

      if (response.ok) {
        setSubmitStatus('success');
        setEmail('');
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="mb-4">
              <img 
                src="https://static.readdy.ai/image/1164fc9bbf614696e93ace8621ec6c97/5a18007f0b98deaa46809201650dd6ef.png" 
                alt="Prop Firm Police Logo" 
                className="h-32 w-auto"
              />
            </div>
            <p className="text-gray-400 mb-6 max-w-md">
              Revolutionary prop firm monitoring system that protects traders from delayed payouts, 
              KYC issues, and bad business practices.
            </p>
            
            {/* Newsletter Signup */}
            <div className="mb-6">
              <h4 className="font-bold text-lg mb-3">Stay Updated</h4>
              <p className="text-gray-400 text-sm mb-4">Get the latest prop firm alerts and updates</p>
              <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3" data-readdy-form id="newsletter_signup">
                <input
                  type="email"
                  name="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  className="flex-1 px-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white placeholder-gray-400 focus:outline-none focus:border-blue-500 text-sm"
                  required
                />
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="px-6 py-2 bg-blue-600 hover:bg-blue-700 disabled:bg-gray-600 text-white rounded-lg font-medium transition-colors whitespace-nowrap cursor-pointer text-sm"
                >
                  {isSubmitting ? 'Subscribing...' : 'Subscribe'}
                </button>
              </form>
              {submitStatus === 'success' && (
                <p className="text-green-400 text-sm mt-2">Successfully subscribed to our newsletter!</p>
              )}
              {submitStatus === 'error' && (
                <p className="text-red-400 text-sm mt-2">Failed to subscribe. Please try again.</p>
              )}
            </div>

            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer">
                <i className="ri-twitter-line w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer">
                <i className="ri-linkedin-line w-5 h-5 flex items-center justify-center"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-full flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer">
                <i className="ri-telegram-line w-5 h-5 flex items-center justify-center"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h3 className="font-bold text-lg mb-4">Features</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Payout Monitoring</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">KYC Alerts</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Review Tracking</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Promo Codes</a></li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-bold text-lg mb-4">Company</h3>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">About Us</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Contact</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Privacy Policy</a></li>
              <li><a href="#" className="text-gray-400 hover:text-white transition-colors cursor-pointer">Terms of Service</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2025 PropFirm Police. All rights reserved.
          </p>
          <a 
            href="https://readdy.ai/?origin=logo" 
            className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer mt-4 md:mt-0"
          >
            Powered by Readdy
          </a>
        </div>
      </div>
    </footer>
  );
}
